export default "__VITE_ASSET__m_ZhLlXL__"